interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
  titleId?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = 'left',
  titleId,
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}>
      <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.3em] text-primary-600">
        <span className="h-px w-6 bg-primary-500" />
        {eyebrow}
      </span>
      <h2 id={titleId} className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
        {title}
      </h2>
      {desc && <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}